import React from "react";
import ExceptionPage from "../../routes/ErrorPage/ExceptionPage";

interface IErrorBoundaryState {
    hasError: boolean
}

class ErrorBoundary extends React.Component<{}, IErrorBoundaryState> {
    public static getDerivedStateFromError() {
        return { hasError: true };
    }

    constructor(props: {}) {
        super(props);
        this.state = { hasError: false };
    }

    public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        /* tslint:disable:no-empty */
    }

    public render() {
        if (this.state.hasError) {
            return(
                <ExceptionPage/>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;


// WEBPACK FOOTER //
// ./src/components/ErrorBoundary/index.tsx